"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.object.values");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Utils = require("@icare/core/lib/utils/Utils");

var _Tooltip = _interopRequireDefault(require("@icare/rhythm-form-react/lib/elements/Tooltip"));

var _FileInput = _interopRequireDefault(require("../FileInput"));

var _FileList = _interopRequireWildcard(require("../FileList"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FileUpload = /*#__PURE__*/function (_React$Component) {
  _inherits(FileUpload, _React$Component);

  var _super = _createSuper(FileUpload);

  function FileUpload(props) {
    var _this;

    _classCallCheck(this, FileUpload);

    _this = _super.call(this, props);
    _this._tooltipId = "tooltip_".concat((0, _Utils.createGuid)());
    return _this;
  }

  _createClass(FileUpload, [{
    key: "renderFileList",
    value: function renderFileList() {
      var files = this.props.files;

      if (!files) {
        return null;
      }

      if (!files.length) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_FileList.default, null, files.map(function (file) {
        return /*#__PURE__*/_react.default.createElement(_FileList.File, {
          key: file.id,
          fileName: file.fileName,
          fileExtension: file.fileExtension,
          fileSize: file.fileSize,
          uploadStatus: file.uploadStatus,
          uploadProgress: file.uploadProgress,
          uploadMessage: file.uploadMessage,
          canRemove: file.canRemove,
          onRemove: file.onRemove ? file.onRemove : function () {}
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          title = _this$props.title,
          TitleTag = _this$props.titleTag,
          tooltip = _this$props.tooltip,
          children = _this$props.children,
          description = _this$props.description,
          files = _this$props.files,
          onAcceptFiles = _this$props.onAcceptFiles,
          onRejectFiles = _this$props.onRejectFiles,
          minSizeInBytes = _this$props.minSizeInBytes,
          maxSizeInBytes = _this$props.maxSizeInBytes,
          maxFileNameLength = _this$props.maxFileNameLength,
          supportedFileTypes = _this$props.supportedFileTypes,
          multiple = _this$props.multiple,
          attrs = _objectWithoutProperties(_this$props, ["className", "title", "titleTag", "tooltip", "children", "description", "files", "onAcceptFiles", "onRejectFiles", "minSizeInBytes", "maxSizeInBytes", "maxFileNameLength", "supportedFileTypes", "multiple"]);

      var classes = (0, _classnames.default)(className, 'ctrl-holder', 'file-upload');
      return /*#__PURE__*/_react.default.createElement("div", _extends({
        className: classes
      }, attrs), title && /*#__PURE__*/_react.default.createElement(TitleTag, {
        className: "file-upload__title"
      }, title, tooltip && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        id: this._tooltipId
      }, tooltip)), (description || children) && /*#__PURE__*/_react.default.createElement("div", {
        className: "file-upload__description"
      }, description || children), /*#__PURE__*/_react.default.createElement(_FileInput.default, {
        buttonAriaLabel: "File upload - ".concat(title),
        onAcceptFiles: onAcceptFiles,
        onRejectFiles: onRejectFiles,
        minSizeInBytes: minSizeInBytes,
        maxSizeInBytes: maxSizeInBytes,
        maxFileNameLength: maxFileNameLength,
        supportedFileTypes: supportedFileTypes,
        multiple: multiple
      }), this.renderFileList());
    }
  }]);

  return FileUpload;
}(_react.default.Component);

FileUpload.defaultProps = {
  className: null,
  title: null,
  titleTag: 'label',
  tooltip: null,
  files: [],
  children: null,
  description: null,
  onAcceptFiles: function onAcceptFiles() {},
  onRejectFiles: function onRejectFiles() {},
  minSizeInBytes: null,
  maxSizeInBytes: null,
  maxFileNameLength: null,
  supportedFileTypes: ['.jpg', '.jpeg', '.png', '.bmp', '.tif', '.tiff', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt', '.rtf', '.zip', '.rar', '.pdf'],
  multiple: null
};
FileUpload.propTypes = {
  className: _propTypes.default.string,
  title: _propTypes.default.string,
  titleTag: _propTypes.default.string,
  tooltip: _propTypes.default.string,
  children: _propTypes.default.node,
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  onAcceptFiles: _propTypes.default.func,
  onRejectFiles: _propTypes.default.func,
  files: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    fileData: _propTypes.default.oneOf(Object.values(_FileList.File.Status)),
    uploadStatus: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
  })),
  minSizeInBytes: _propTypes.default.number,
  maxSizeInBytes: _propTypes.default.number,
  maxFileNameLength: _propTypes.default.number,
  supportedFileTypes: _propTypes.default.arrayOf(_propTypes.default.string),
  multiple: _propTypes.default.bool
};
var _default = FileUpload;
exports.default = _default;
//# sourceMappingURL=FileUpload.js.map